import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { AppBar } from "../../components/AppShell";
import { request } from "../../lib/api";
import { coverFor, fmtDuration } from "../../lib/helpers";
import type { CourseListItem, CourseProgress } from "../../lib/types";

export function MyCourses() {
  const { data, isLoading } = useQuery({
    queryKey: ["me", "enrollments"],
    queryFn: () => request<CourseListItem[]>("/enrollments/me"),
  });

  return (
    <>
      <AppBar crumbs={[{ label: "Tabloul meu", to: "/student/dashboard" }, { label: "Cursurile mele" }]} />
      <div className="content">
        <div className="page-head">
          <div>
            <h1>Cursurile mele</h1>
            <p>Toate cursurile la care ești înscris.</p>
          </div>
        </div>
        {isLoading ? (
          <div className="card text-muted">Se încarcă…</div>
        ) : data && data.length > 0 ? (
          <div className="grid-3">{data.map((c) => <CourseCard key={c.id} course={c} />)}</div>
        ) : (
          <div className="card text-muted" style={{ textAlign: "center", padding: 48 }}>
            Nu ești înscris la niciun curs. <Link to="/student/catalog">Explorează catalogul</Link>.
          </div>
        )}
      </div>
    </>
  );
}

function CourseCard({ course }: { course: CourseListItem }) {
  const progress = useQuery({
    queryKey: ["me", "course-progress", course.id],
    queryFn: () => request<CourseProgress>(`/me/courses/${course.id}/progress`),
  });
  const p = progress.data;
  const pct = p?.percent ?? 0;
  return (
    <article className="course-card">
      <div className="course-cover" style={{ background: coverFor(course) }}>
        <span className="tag">{pct}%</span>
        <div><div className="module">{course.category}</div><strong>{course.title}</strong></div>
      </div>
      <div className="course-body">
        <div className="course-meta">
          <span><i className="fa-solid fa-list-check"></i> {p ? `${p.completed_lessons} / ${p.total_lessons} lecții` : "—"}</span>
          <span><i className="fa-regular fa-clock"></i> {fmtDuration(course.duration_minutes)}</span>
        </div>
        <div className="course-progress"><span style={{ width: `${pct}%` }}></span></div>
        <div className="course-footer">
          <span className="pct">{pct}% finalizat</span>
          {pct >= 100
            ? <Link to={`/student/examen/${course.id}`} className="btn btn-accent btn-sm">Examen</Link>
            : <Link to={`/student/curs/${course.id}`} className="btn btn-primary btn-sm">Continuă</Link>}
        </div>
      </div>
    </article>
  );
}
